const defaultErrorCodes = {
  DEFAULT_ERROR: 'default.error',
  DEFAULT_SERVER_ERROR: 'default.server.error',
};

export default defaultErrorCodes;
